import {all} from "redux-saga/effects";
import forkWithErrHandler from "../../../shared/utils/forkWithErrHandler";
import purchaseWorker from "./purchaseWorker";
import checkIfAvailable from "./checkIfAvailable";
import { SDK } from "../../../sdk";

export default function* paymentsSaga() {
    if (!SDK.instance.supports.payments) {
        return;
    }

    yield all([
        forkWithErrHandler("paymentsSaga", "checkIfAvailable", checkIfAvailable),
        forkWithErrHandler("paymentsSaga", "purchase", purchaseWorker)
    ]);
}